/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionItemCreateRequest } from '../models/ActionItemCreateRequest';
import type { ActionItemMessageResponse_Input } from '../models/ActionItemMessageResponse_Input';
import type { ActionItemMessageUpdateRequest } from '../models/ActionItemMessageUpdateRequest';
import type { ActionItemResponse_Input } from '../models/ActionItemResponse_Input';
import type { ActionItemUpdateRequest } from '../models/ActionItemUpdateRequest';
import type { PaginatedResponse_ActionItemResponse__Input } from '../models/PaginatedResponse_ActionItemResponse__Input';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ActionItemRoutesRepository {
  /**
   * Get List
   * Get list of action items.
   * @returns PaginatedResponse_ActionItemResponse__Input Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesGetList({
    contractorId,
    jobId,
    jobIds,
    jobTaskId,
    isResolved,
    isDeleted,
    pageNumber = 1,
    perPage = 50,
    authorization,
  }: {
    contractorId?: (string | null),
    jobId?: (string | null),
    jobIds?: (Array<string> | null),
    jobTaskId?: (string | null),
    isResolved?: (boolean | null),
    isDeleted?: (boolean | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_ActionItemResponse__Input> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/action_items',
      headers: {
        'authorization': authorization,
      },
      query: {
        'contractor_id': contractorId,
        'job_id': jobId,
        'job_ids': jobIds,
        'job_task_id': jobTaskId,
        'is_resolved': isResolved,
        'is_deleted': isDeleted,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Action Item
   * Create a new action item.
   * @returns ActionItemResponse_Input Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesCreateActionItem({
    requestBody,
    authorization,
  }: {
    requestBody: ActionItemCreateRequest,
    authorization?: string,
  }): CancelablePromise<ActionItemResponse_Input> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/action_items',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Action Item
   * Update an action item.
   * @returns ActionItemResponse_Input Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesUpdateActionItem({
    actionItemId,
    requestBody,
    authorization,
  }: {
    actionItemId: string,
    requestBody: ActionItemUpdateRequest,
    authorization?: string,
  }): CancelablePromise<ActionItemResponse_Input> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/action_items/{action_item_id}',
      path: {
        'action_item_id': actionItemId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Resolve Action Item
   * Resolves an action item.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesResolveActionItem({
    actionItemId,
    authorization,
  }: {
    actionItemId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/action_items/{action_item_id}/resolve',
      path: {
        'action_item_id': actionItemId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Action Item
   * Resolves an action item.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesDeleteActionItem({
    actionItemId,
    authorization,
  }: {
    actionItemId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/action_items/{action_item_id}/delete',
      path: {
        'action_item_id': actionItemId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Action Item Message
   * Create an action item message.
   * @returns ActionItemMessageResponse_Input Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesCreateActionItemMessage({
    actionItemId,
    requestBody,
    authorization,
  }: {
    actionItemId: string,
    requestBody: ActionItemMessageUpdateRequest,
    authorization?: string,
  }): CancelablePromise<ActionItemMessageResponse_Input> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/action_items/{action_item_id}/messages',
      path: {
        'action_item_id': actionItemId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Action Item Message
   * Update an action item message.
   * @returns ActionItemMessageResponse_Input Successful Response
   * @throws ApiError
   */
  public static actionItemRoutesUpdateActionItemMessage({
    actionItemId,
    messageId,
    requestBody,
    authorization,
  }: {
    actionItemId: string,
    messageId: string,
    requestBody: ActionItemMessageUpdateRequest,
    authorization?: string,
  }): CancelablePromise<ActionItemMessageResponse_Input> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/action_items/{action_item_id}/messages/{message_id}',
      path: {
        'action_item_id': actionItemId,
        'message_id': messageId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Action Item Message
   * Delete an action item message.
   * @returns void
   * @throws ApiError
   */
  public static actionItemRoutesDeleteActionItemMessage({
    actionItemId,
    messageId,
    authorization,
  }: {
    actionItemId: string,
    messageId: string,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/action_items/{action_item_id}/messages/{message_id}',
      path: {
        'action_item_id': actionItemId,
        'message_id': messageId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
